import { useEffect } from "react";
import { X } from "lucide-react";

/** In-app photo viewer: keeps users (especially mobile/PWA) inside the app with
 *  an obvious way back — X button, backdrop tap, or Escape. Use for images only;
 *  PDFs still open in a new tab where the browser provides its own viewer. */
export default function ImageLightbox({ src, alt = "", testid = "image-lightbox", onClose }) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [src, onClose]);
  if (!src) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-zinc-950/90 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose} data-testid={testid}>
      <button type="button" onClick={onClose} aria-label="Close photo" data-testid={`${testid}-close`}
        className="absolute top-4 right-4 h-11 w-11 rounded-full bg-white/10 hover:bg-white/20 text-white inline-flex items-center justify-center transition-colors duration-200">
        <X className="h-5 w-5" />
      </button>
      <img src={src} alt={alt} onClick={(e) => e.stopPropagation()}
        className="max-w-full max-h-[85dvh] rounded-lg shadow-2xl object-contain" data-testid={`${testid}-img`} />
    </div>
  );
}
